export default __webpack_public_path__ + "b6807f2a8d925e261cdceceea6f6d8df.png";